import { Box, CardContent, makeStyles, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { styles } from './emptyContent.styles'

export interface EmptyContentProps {
  caption?: string
  className?: string
}

export const EmptyContent: React.FC<EmptyContentProps> = ({
  caption = '',
  children,
  className = ''
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return (
    <Box className={classes.cardContent || `${className}`}>
      {caption && (
        <Box mb={1}>
          <Typography variant="subtitle1">{caption}</Typography>
        </Box>
      )}
      <Box>{children}</Box>
    </Box>
  )
}
